import styled from 'styled-components';
import { fadeIn, fadeInUp } from './Animations';

export const Container = styled.div`
  background-color: #fff;
  color: #000;
  background-color: #F2F2F2;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  padding: 100px;
  width: 80%;
  margin: 0 auto;
  gap: 50px;
  max-width: 1500px;
  animation: ${fadeIn} 1s ease-out;

  @media (max-width: 550px) {
    /* Phones */
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0 30px 0px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0 30px 0px;
  }
`;

export const ContactDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  animation: ${fadeInUp} 1s ease-out;

  img{
    width: 100%;

  @media (max-width: 550px) {
    /* Phones */
    position: absolute;
    width: 60%;
    right: 0;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    position: absolute;
    width: 60%;
    right: 0;
  }
  }
`;

export const Logo = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 50%;
`;

export const Info = styled.div`
  p:nth-child(1){
    font-size: 1.2em;
    font-weight: bold;
    text-transform: uppercase;
  }

  font-size: 0.9rem;
  animation: ${fadeInUp} 1s ease-out 0.2s backwards;

  @media (max-width: 550px) {
    /* Phones */
    margin-top: -100px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    margin-top: -100px;
  }
`;

export const SocialIcons = styled.div`
  font-size: 1.3em;
  display: flex;
  gap: 10px;
  animation: ${fadeInUp} 1s ease-out 0.4s backwards;
`;

export const Icon = styled.div`
  font-size: 1.5rem;
  cursor: pointer;
`;

export const Form = styled.form`
  width: 100%;
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 30px;
  animation: ${fadeInUp} 1s ease-out 0.3s backwards;
`;

export const InputRow = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 550px) {
    /* Phones */
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const InputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  animation: ${fadeIn} 0.8s ease-out;

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
  }
`;

export const Label = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  background-color: #E7E7E7;
`;

export const TextArea = styled.textarea`
  padding: 15px 20px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  min-height: 100px;
  border-radius: 30px;
  background-color: #E7E7E7;
`;

export const SubmitButton = styled.button`
  align-self: flex-end;
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;
  animation: ${fadeInUp} 1s ease-out 0.6s backwards;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
    transform: translateY(-2px);
  }
`;
